import React from "react";
import { motion } from "framer-motion";
import type { ChatMessage, ChatHistoryResponse } from "@/types/discuss.types";
import Message from "./Message";
import DiscussBulkActions from "./DiscussBulkActions";
import {
  getBackendDocumentId,
  getDocumentTitle,
  type BackendDocumentRef,
} from "@/utils/document-id.utils";

interface AssistantMessageBlockProps {
  message: ChatMessage;
  index: number;
  isLastItem: boolean;
  isLastAssistant: boolean;
  hasActiveTask: boolean;
  isCompassProcessing: boolean;
  isSendingMessage: boolean;
  lastMessageRef: React.RefObject<HTMLDivElement>;
  doc: BackendDocumentRef | undefined;
  historyData: ChatHistoryResponse | undefined;
  onRelatedQuestionClick: (question: string) => void;
}

export const AssistantMessageBlock: React.FC<AssistantMessageBlockProps> = ({
  message,
  index,
  isLastItem,
  isLastAssistant,
  hasActiveTask,
  isCompassProcessing,
  isSendingMessage,
  lastMessageRef,
  doc,
  historyData,
  onRelatedQuestionClick,
}) => (
  <motion.div
    initial={{ opacity: 0, x: -20 }}
    animate={{ opacity: 1, x: 0 }}
    transition={{ duration: 0.3, ease: "easeOut" }}
    className="w-full"
    ref={isLastItem && !hasActiveTask ? lastMessageRef : null}
  >
    <Message
      type="assistant"
      message={message.response ?? ""}
      creation_date={message.creation_date ?? ""}
      messageObject={message}
      relatedQuestions={
        isCompassProcessing || isSendingMessage || hasActiveTask ? [] : message.related_questions
      }
      onRelatedQuestionClick={onRelatedQuestionClick}
      requestType="discuss"
      documentId={getBackendDocumentId(doc)}
      documentTitle={getDocumentTitle(doc)}
      prevMessage={historyData?.prev_chat?.[index - 1]}
      bulkActions={
        isLastAssistant && !hasActiveTask ? (
          <DiscussBulkActions
            messages={historyData?.prev_chat ?? []}
            documentId={getBackendDocumentId(doc)}
            documentTitle={getDocumentTitle(doc)}
          />
        ) : undefined
      }
    />
  </motion.div>
);
